import type {
  SprengnetterValuationHubValuationPackageModelResponseAvmPriceResponse as PackageAvmPriceResponse,
  SprengnetterValuationHubValuationReportModelResponseAvmPriceResponse as ReportAvmPriceResponse,
  ValuationHubCoreModelRealEstateAvmEquipmentPriceRange,
} from "@/api/generatedApi";

export type AvmPriceResponse = PackageAvmPriceResponse | ReportAvmPriceResponse | null | undefined;
export type AvmSelectedEquipmentPriceRange =
  | Pick<ValuationHubCoreModelRealEstateAvmEquipmentPriceRange, "min" | "max">
  | null
  | undefined;

interface AvmDisplayedRange {
  min: number | null;
  max: number | null;
}

const hasSelectedEquipmentRange = (avmPrice: AvmPriceResponse): avmPrice is PackageAvmPriceResponse =>
  !!avmPrice && typeof avmPrice === "object" && "selected_equipment_price_range" in avmPrice;

export const getAvmBaseRange = (avmPrice: AvmPriceResponse): AvmDisplayedRange => ({
  min: avmPrice?.min ?? null,
  max: avmPrice?.max ?? null,
});

export const getAvmSelectedRange = (
  avmPrice: AvmPriceResponse,
  selectedRangeOverride?: AvmSelectedEquipmentPriceRange,
): AvmDisplayedRange => {
  if (selectedRangeOverride?.min != null || selectedRangeOverride?.max != null) {
    return {
      min: selectedRangeOverride?.min ?? null,
      max: selectedRangeOverride?.max ?? null,
    };
  }

  if (!hasSelectedEquipmentRange(avmPrice)) {
    return {
      min: null,
      max: null,
    };
  }

  return {
    min: avmPrice.selected_equipment_price_range?.min ?? null,
    max: avmPrice.selected_equipment_price_range?.max ?? null,
  };
};

export const getAvmDisplayedRange = (
  avmPrice: AvmPriceResponse,
  selectedRangeOverride?: AvmSelectedEquipmentPriceRange,
): AvmDisplayedRange => {
  const baseRange = getAvmBaseRange(avmPrice);
  const selectedRange = getAvmSelectedRange(avmPrice, selectedRangeOverride);

  return {
    min: selectedRange.min ?? baseRange.min,
    max: selectedRange.max ?? baseRange.max,
  };
};
